import React from 'react';
import PropTypes from 'prop-types';
import {Manager, Target, Popper} from 'react-popper';
import classNames from 'classnames';
import {v4 as uuid} from 'uuid';

import IconButton from '@material-ui/core/IconButton';
import Grow from '@material-ui/core/Grow';
import ClickAwayListener from '@material-ui/core/ClickAwayListener';
import {useMediaQuery, useTheme} from '@material-ui/core';

function SidebarActionTemplate(props) {
  const {
    actionName,
    children,
    classes,
    handleClick,
    handleClose,
    icon,
    isOpen,
  } = props;

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  const managerStyle = {display: 'inline-block'};
  const growStyle = {transformOrigin: isMobile ? 'top' : 'bottom left'};

  return (
    <ClickAwayListener onClickAway={handleClose}>
      <Manager style={managerStyle} className={classes.root}>
        <Target>
          <IconButton
            color="inherit"
            className={classes.button}
            onClick={handleClick}
          >
            <div className={classes.button__text}>
              {icon}
              {actionName}
            </div>
          </IconButton>
        </Target>
        <Popper
          placement={isMobile ? 'bottom' : 'right-end'}
          eventsEnabled={isOpen}
          positionFixed={true}
          className={classNames(
            classes.popper_responsive,
            {
              [classes.popper_close]: !isOpen,
            },
          )}
          modifiers={{
            preventOverflow:
              {
                enabled: false,
                escapeWithReference: true,
                boundariesElement: 'viewport',
              },
          }}
        >
          <Grow
            in={isOpen}
            id={uuid()}
            style={growStyle}
          >
            {children}
          </Grow>
        </Popper>
      </Manager>
    </ClickAwayListener>
  );
}

SidebarActionTemplate.propTypes = {
  actionName: PropTypes.string.isRequired,
  children: PropTypes.node,
  classes: PropTypes.object.isRequired,
  handleClick: PropTypes.func.isRequired,
  handleClose: PropTypes.func.isRequired,
  icon: PropTypes.node.isRequired,
  isOpen: PropTypes.bool.isRequired,
};

SidebarActionTemplate.defaultProps = {
  children: '',
};

export default SidebarActionTemplate;
